import { createContext } from 'react';
const BreakpointContext = /*#__PURE__*/createContext({
  breakpoints: {
    active: []
  }
});
const {
  Provider,
  Consumer
} = BreakpointContext;
export { Provider, Consumer };
export default BreakpointContext;